import { useRef, useEffect } from "react";
import { ShortLineModel } from "../../products/models/ProductModel";
import FavoriteItemView from "./FavoriteItemView";
import useFavoriteVM from "../viewmodels/FavoriteVM";

export default function FavoriteView() {
    const hasLoaded = useRef(false);

    const vm = useFavoriteVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList();
    }, [vm]);

    const onDelete = (item: ShortLineModel) => {
        const msg = "Would you like to remove the product from favorite?";

        if (window.confirm(msg)) {
            vm.set(item.id, true, true, () => { });
        }
    }

    return <div className="ph-10" style={{ maxWidth: 800 }}>
        <div className="font-title left pb-15">Favorites</div>

        {vm.list.map((item: ShortLineModel, index?: number) => {
            return <div key={item.id}>
                <FavoriteItemView item={item} onDelete={onDelete} />

                <div className="pv-20">
                    <hr color="lightGray" style={{ height: 1, border: "none" }} />
                </div>
            </div>
        })}
    </div>
}